<template>
  <div class="table-responsive">
    <table class="table w-full table-data min-w-table">
      <thead>
        <tr>
          <th style="padding: 1rem; padding-bottom: .75rem;">
            <input
              id="toggleAll"
              type="checkbox"
              name="toggleAll"
              :checked="allOnPageAreSelected"
              @click="toggleAll"
            >
            <label
              for="toggleAll"
              class="checkbox h-4 w-4"
              style="padding: 0 !important; margin: 0 -.5rem 0 0 !important;"
            />
          </th>
          <th v-text="'First name'" />
          <th v-text="'Last name'" />
          <th v-text="'Email'" />
          <th v-text="'Groups'" />
          <th v-text="'Status'" />
        </tr>
      </thead>
      <tbody v-if="memberships.length">
        <tr
          is="Row"
          v-for="membership in memberships"
          :key="membership.uuid"
          :membership="membership"
          selectable
        />
      </tbody>
      <tbody v-else>
        <tr>
          <td
            class="text-center"
            colspan="6"
            v-text="'No results'"
          />
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script type="text/babel">
import { mapMutations } from 'vuex'
import HasSelectedMemberships from 'Membership/Resources/assets/js/components/bulk-edit/mixins/HasSelectedMemberships'
import Row from 'Membership/Resources/assets/js/components/bulk-edit/MembershipRow'

export default {
  name: 'MembershipsTable',
  components: {
    Row,
  },
  mixins: [HasSelectedMemberships],
  props: {
    memberships: {
      type: Array,
      required: true,
    },
  },
  computed: {
    allOnPageAreSelected() {
      let val = true

      this.memberships.forEach((membership) => {
        if (this.selectedMemberships.findIndex(({ uuid }) => uuid === membership.uuid) === -1) {
          val = false
        }
      })

      return val
    },
  },
  methods: {
    ...mapMutations({
      toggleAllSelectedMemberships: 'membershipToggleAllSelectedMemberships',
    }),
    toggleAll() {
      this.toggleAllSelectedMemberships({
        memberships: this.memberships,
        toggleType: this.allOnPageAreSelected ? 'remove' : 'add',
      })
    },
  },
}
</script>
